// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2eRJx","type":"styles_type__r50iU","choices":"styles_choices__3G2xx"};